module.exports = __webpack_public_path__ + "static/media/photo-instructions1.6c3ad8bc.png";